<template>
  <span class="image-search-icon" aria-hidden="true">
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M1 4.64005C1 3.29592 1 2.62386 1.26158 2.11047C1.49168 1.65888 1.85883 1.29173 2.31042 1.06163C2.82381 0.800049 3.49587 0.800049 4.84 0.800049H13.16C14.5041 0.800049 15.1762 0.800049 15.6896 1.06163C16.1412 1.29173 16.5083 1.65888 16.7384 2.11047C17 2.62386 17 3.29592 17 4.64005V11.36C17 12.7042 17 13.3762 16.7384 13.8896C16.5083 14.3412 16.1412 14.7084 15.6896 14.9385C15.1762 15.2 14.5041 15.2 13.16 15.2H4.84C3.49587 15.2 2.82381 15.2 2.31042 14.9385C1.85883 14.7084 1.49168 14.3412 1.26158 13.8896C1 13.3762 1 12.7042 1 11.36V4.64005Z"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 11.2C10.7673 11.2 12.2 9.76736 12.2 8.00005C12.2 6.23274 10.7673 4.80005 9 4.80005C7.23269 4.80005 5.8 6.23274 5.8 8.00005C5.8 9.76736 7.23269 11.2 9 11.2Z"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  </span>
</template>

<script>
export default {
  name: "ImageSearchIcon",
};
</script>

<style lang="scss" scoped>
.image-search-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: inherit;
  line-height: 0;
  svg {
    display: block;
    width: 18px;
    height: 16px;
  }
}
</style>
